import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { createElement } from 'react';
import { unmountComponentAtNode, render } from 'react-dom';
import { StyledMessage } from "./styled"; // @notice: import at _app.ts
// import './Message.css'

import trace from "../../ga";
export var TokenlonMessage = function TokenlonMessage(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'success' : _ref$type,
      children = _ref.children;
  return __jsx(StyledMessage, {
    type: type
  }, children);
};
export var Message = /*#__PURE__*/function () {
  function Message() {
    _classCallCheck(this, Message);

    _defineProperty(this, "container", void 0);

    _defineProperty(this, "error", this.showMessageBox('error'));

    _defineProperty(this, "success", this.showMessageBox('success'));
  }

  _createClass(Message, [{
    key: "destroyAll",
    value: function destroyAll() {
      while (this.container.firstChild) {
        this.destroy(this.container.firstChild);
      }
    }
  }, {
    key: "destroy",
    value: function destroy(div) {
      var unmountResult = unmountComponentAtNode(div);
      if (unmountResult && div.parentNode) div.parentNode.removeChild(div);
    }
  }, {
    key: "showMessageBox",
    value: function showMessageBox(type) {
      if (typeof window !== 'undefined' && window['imToken']) {
        return function (content) {
          window.imToken.callAPI('native.toast', {
            type: type === 'error' ? 'warning' : type,
            message: content,
            align: 'top',
            model: 'banner',
            duration: 3000
          });
        };
      }

      if (!this.container && typeof document !== 'undefined') {
        this.container = document.createElement('div');
        this.container.classList = 'message-container';
        document.body.appendChild(this.container);
      }

      return function createMessageBox(content) {
        var _this = this;

        var div = document.createElement('div');
        this.container.insertBefore(div, this.container.firstChild);
        var Box = /*#__PURE__*/createElement(TokenlonMessage, {
          type: type
        }, content);
        render(Box, div);
        trace.view('view_toast_message', {
          type: type,
          content: content
        }); // todo: @izayl extract duration

        setTimeout(function () {
          _this.destroy(div);
        }, 3000);
      };
    }
  }]);

  return Message;
}();
export var message = new Message();